// Third Party
import {
  NextPage,
  GetServerSidePropsContext,
  InferGetServerSidePropsType,
} from 'next';

// Utils
import { routes, canonicalUrlForPath } from '@routes';
import { getFlashMessage, removeFlashMessage } from '@utils/flash-message';
import { auth } from '@auth';

// UI
import { PublicLayout } from '@layouts/public-layout';
import { Login } from '@pages-components/login';

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const session = await auth(context);

  const message = getFlashMessage(context);

  if (message) removeFlashMessage(context);

  if (session?.user?.accessToken) {
    return {
      redirect: {
        destination: context.query?.callbackUrl || routes.home,
        permanent: false,
      },
      props: {
        session,
      },
    };
  } else {
    if (message) {
      return {
        props: {
          message,
          session: null,
          redirectUrl: (context.query?.callbackUrl as string) || routes.home,
        },
      };
    } else {
      return {
        props: {
          session: null,
          redirectUrl: (context.query?.callbackUrl as string) || routes.home,
        },
      };
    }
  }
}

/**
 * This page is visible to unauthenticated and authenticated users
 */
const LoginPage: NextPage<
  InferGetServerSidePropsType<typeof getServerSideProps>
> = ({ session, message, redirectUrl }) => {
  return (
    <PublicLayout
      session={session}
      loadingSession={false}
      canonicalUrl={canonicalUrlForPath(routes.login)}
      pageTitle={'Login | Savvy'}
      pageDescription="Login to your Savvy account"
    >
      <Login message={message} redirectUrl={redirectUrl} />
    </PublicLayout>
  );
};

export default LoginPage;
